import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'canceled-guest',
  templateUrl: './canceled-guest.component.html',
  styleUrls: ['./canceled-guest.component.scss']
})
export class CanceledGuestComponent {
  title: string;
  constructor(private translate: TranslateService) {
    this.translate.use('hu')
    this.title = translate.instant('canceledguest.title')

  }
}
